(function (app) {
    app.factory('jobApplyFactory', ["hUser", "hEvent", "JobDetailsBus", "$filter", "$q", function (hUser, hEvent, JobDetailsBus, $filter, $q) {
        let jobApplyFactory = {};
        jobApplyFactory.ERRORS = {
            LOCALIZATION_APPLY_ERROR: 'LOCALIZATION_APPLY_ERROR',
            USER_ALREADY_APPLIED: 'USER_ALREADY_APPLIED',
            USER_ALREADY_EXISTS_ON_TALENT_POOL: 'USER_ALREADY_EXISTS_ON_TALENT_POOL',
        }
        jobApplyFactory.PrepareApplySuccessModal = async (jobIds, status, isMultipleApply) => {
            const defer = $q.defer();
            let returnData = {};
            returnData.isPrivacyShield = hUser.isPrivacyShieldOn();
            returnData.profileScore = 0;
            returnData.WEAK = DashboardAPI.WEAK;
            returnData.GOOD = DashboardAPI.GOOD;
            returnData.MODERATE = DashboardAPI.MODERATE;
            returnData.OUTSTANDING = DashboardAPI.OUTSTANDING;
            returnData.successData = [];
            returnData.completedWotc = status === JobDetailsBus.WOTC_SUCCESS;
            returnData.isMultipleApply = !!isMultipleApply;

            if (!Array.isArray(jobIds)) {
                jobIds = [jobIds];
            }

            for (let jobId of jobIds) {
                if (JobDetailsBus.getIsNoPassword(jobId)) {
                    returnData.isPrivacyShield = false;
                    returnData.isNoPasswordCheck = true;
                    hEvent.track("success_shown", { category: 'job_apply', label: 'no_password' });
                }
            }

            if (!hUser.isLoggedIn()) {
                defer.resolve(returnData);
            }

            try {
                const data = await DashboardAPI.getProfileStrength();
                returnData.profileScore = data.profStrength;
                returnData.profileStrengthCode = data.code;
                returnData.noRecommendations = true;

                for (let jobId of jobIds) {
                    const jobDetails = await JobDetailsBus.getJob(jobId);
                    returnData.successData.push({
                        job: jobDetails.job,
                        brand: jobDetails.brand
                    });
                    returnData.profileSuggestedActions = data.missingItems;
                    hEvent.track("success_shown", { category: 'job_apply', label: 'career_port_' + data.profStrength });
                }
                defer.resolve(returnData);
            } catch (error) {
                console.error(error);
                defer.reject(error);
            }
            return defer.promise;
        };

        jobApplyFactory.showApplySuccessModal = () => {
            $('#apply-success-modal').on('show.bs.modal', () => {
                setTimeout(() => {
                    $('#apply-success-modal').removeClass('before-animation');
                }, 250);
            }).on('hide.bs.modal', () => {
                $('#apply-success-modal').addClass('before-animation');
            }).modal('show');
        }

        jobApplyFactory.getCandidateApplyStatus = async (brandId) => {
            const candidateStatus = await BrandAPI.getCandidateProfileApplyStatus(brandId);
            if (candidateStatus.profile_type === BrandAPI.PROFILE_TYPES.MARKETPLACE && candidateStatus.has_localized_profile_on_business
                || candidateStatus.profile_type === BrandAPI.PROFILE_TYPES.LOCALIZED && !candidateStatus.has_localized_profile_on_business) {
                throw {data: candidateStatus, code: jobApplyFactory.ERRORS.LOCALIZATION_APPLY_ERROR};
            }
        }

        jobApplyFactory.handleApplicationFlowLocalizationErrorMessage = (candidateStatus) => {
            let message = '';
            if (candidateStatus.profile_type === BrandAPI.PROFILE_TYPES.MARKETPLACE && candidateStatus.has_localized_profile_on_business) {
                message = $filter('translate')('Please login to your employment account at ') + (candidateStatus.business_details.external_business_name || candidateStatus.business_details.name) + $filter('translate')(' first to submit your application.');
            } else if (candidateStatus.profile_type === BrandAPI.PROFILE_TYPES.LOCALIZED && !candidateStatus.has_localized_profile_on_business && candidateStatus.has_marketplace_profile) {
                message = $filter('translate')('Please login to your general account first to submit your application to ') + (candidateStatus.business_details.external_business_name || candidateStatus.business_details.name);
            } else if (candidateStatus.profile_type === BrandAPI.PROFILE_TYPES.LOCALIZED && !candidateStatus.has_localized_profile_on_business && !candidateStatus.has_marketplace_profile) {
                message = $filter('translate')('Please signup first to get a general account to submit your application to ') + (candidateStatus.business_details.external_business_name || candidateStatus.business_details.name);
            }
            return message;
        }

        return jobApplyFactory;
    }]);

})(angular.module('harriApp'));
